// The files given to a class, for its instructor (RFC-054 §5,
// byj-1wv.70.5): each opened on its own page, or taken back, asked first;
// a file of the instructor's given to the class here, through ClassGiven as a
// class's templates are (byj-1wv.83). Every member sees what is given; what
// students hand in is on each assignment's page.
import { api, type ClassDetail, type ShareFile } from "../api";
import { navigate } from "../router";
import { t } from "../i18n";
import { ClassGiven } from "./ClassGiven";
import { FileRow } from "./FileRow";

/** The calls the tab makes, so a test can supply its own. */
export type ClassFilesApi = Pick<typeof api, "classFiles" | "files" | "giveFile" | "takeFile">;

export function ClassFiles({ cls, onCount, client = api }: {
  cls: ClassDetail;
  /** how many files it found, for its tab's count */
  onCount?: (n: number) => void;
  client?: ClassFilesApi;
}) {
  return (
    <ClassGiven<ShareFile>
      of={cls.id}
      source={{
        given: () => client.classFiles(cls.id),
        // a file handed in is a student's to keep, not material to give
        mine: async () => (await client.files()).mine.filter((f) => !f.hand_in && f.latest > 0),
        give: (id) => client.giveFile(id, cls.id),
        take: (id) => client.takeFile(id, cls.id),
      }}
      onCount={onCount}
      row={(x, take) => <FileRow key={x.id} f={x} menu={[{ label: t("files:openFile"), onSelect: () => navigate(`/f/${encodeURIComponent(x.id)}`) }, ...take]} />}
      label={(x) => x.name}
      words={{
        take: t("files:classFileTake"),
        takeAsk: (name) => t("files:classFileTakeAsk", { name, cls: cls.name }),
        givePick: t("files:classFileGivePick"),
        give: t("files:classFileGive"),
        noneToGive: t("files:classFileNoneToGive"),
        none: t("files:noClassFiles"),
        noneLead: t("files:noClassFilesLead"),
      }}
      testid="class-file"
    />
  );
}
